import { createSmartrrModal } from "@vendor-app/utils/createModalStore";
import { EmailPreviewModalProps } from "..";

export const useEmailPreviewModalStore = createSmartrrModal<EmailPreviewModalProps>();
